import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, MousePointerClick, Clock, ArrowDownRight, CheckSquare, Heart, Smartphone, TrendingUp } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide13Optimization({
  index
}: SlideProps) {
  const metrics = [{
    icon: MousePointerClick,
    label: 'Click-through rate'
  }, {
    icon: CheckSquare,
    label: 'Completion rate'
  }, {
    icon: Clock,
    label: 'Average view time'
  }, {
    icon: ArrowDownRight,
    label: 'Drop-off points'
  }, {
    icon: BarChart3,
    label: 'Quiz and poll participation'
  }, {
    icon: Heart,
    label: 'Topic preference'
  }, {
    icon: Smartphone,
    label: 'Engagement by channel'
  }, {
    icon: TrendingUp,
    label: 'Campaign-to-campaign improvement'
  }];
  return <InteriorSlide data-id="element-270">
      <SlideHeader eyebrow="Monitoring & Optimization" data-id="element-271">
        Every campaign creates data for the next campaign
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-272">
        {/* Left: Data Loop */}
        <div className="flex-1 w-full" data-id="element-273">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="bg-[var(--surface)] p-8 rounded-3xl border border-black/5 relative" data-id="element-274">
            <div className="flex flex-col items-center gap-6 relative z-10" data-id="element-275">
              <div className="bg-white px-6 py-3 rounded-xl shadow-sm font-bold text-[var(--fg)] border border-black/5 w-48 text-center" data-id="element-276">
                Campaign 1
              </div>

              <div className="h-8 w-0.5 bg-[var(--brand)]/30" data-id="element-277" />

              <div className="bg-[var(--brand)] text-white px-6 py-3 rounded-xl shadow-md font-bold w-56 text-center" data-id="element-278">
                Engagement Data
              </div>

              <div className="h-8 w-0.5 bg-[var(--brand)]/30" data-id="element-279" />

              <div className="bg-white px-6 py-3 rounded-xl shadow-sm font-bold text-[var(--brand)] border-2 border-[var(--brand)] w-48 text-center" data-id="element-280">
                Insight
              </div>

              <div className="h-8 w-0.5 bg-[var(--brand)]/30" data-id="element-281" />

              <div className="bg-[var(--brand-light)] text-white px-6 py-3 rounded-xl shadow-md font-bold w-56 text-center" data-id="element-282">
                Optimization
              </div>

              <div className="h-8 w-0.5 bg-[var(--brand)]/30" data-id="element-283" />

              <div className="bg-white px-6 py-3 rounded-xl shadow-sm font-bold text-[var(--fg)] border border-black/5 w-48 text-center" data-id="element-284">
                Campaign 2
              </div>
            </div>

            {/* Loop connecting line */}
            <div className="absolute top-12 bottom-12 right-12 w-12 border-t-2 border-r-2 border-b-2 border-dashed border-[var(--brand)]/30 rounded-r-3xl" data-id="element-285" />
          </motion.div>
        </div>

        {/* Right: Metrics Grid */}
        <div className="flex-1 w-full" data-id="element-286">
          <motion.h3 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4
        }} className="text-lg font-bold text-[var(--fg)] mb-6" data-id="element-287">
            Key Metrics Captured
          </motion.h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-288">
            {metrics.map((metric, i) => {
            const Icon = metric.icon;
            return <motion.div key={metric.label} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.5 + i * 0.05,
              duration: 0.4
            }} className="bg-white p-4 rounded-xl border border-black/5 shadow-sm flex items-center gap-3" data-id="element-289">
                  <div className="h-8 w-8 rounded-lg bg-[var(--surface)] flex items-center justify-center text-[var(--brand)] flex-shrink-0" data-id="element-290">
                    <Icon className="h-4 w-4" data-id="element-291" />
                  </div>
                  <span className="text-sm font-semibold text-[var(--fg)] leading-tight" data-id="element-292">
                    {metric.label}
                  </span>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </InteriorSlide>;
}